import type { CardHooks } from "./registry";

/**
 * Blind-Side Follow Up — Attack/Defend.
 *
 * Attack side: gains Quick if a chain attack happened earlier in the round
 *   (chainStreak >= 1). Granted via slotKeywordGrants so the keyword is
 *   conditional, not baked into the card's keywords list.
 *
 * Defend side: if SELF started the round as the aggressor (originalAggressor),
 *   subtract 2 power from the opposing attack in the combat slot. Engine
 *   handles the slot lookup + adValueOverrides write via the
 *   weakenOpposingAttackPower hook field.
 */
export const blindSideFollowUp: CardHooks = {
  onAttackPlay: (ctx) => {
    if (ctx.game.chainStreak >= 1) {
      return {
        slotKeywordGrants: ["Quick"],
        log: [`${ctx.card.name} gains Quick from chain momentum.`],
      };
    }
    return {};
  },

  onDefendPlay: (ctx) => {
    if (ctx.game.originalAggressor !== ctx.self.num) return {};
    return {
      weakenOpposingAttackPower: 2,
      log: [
        `${ctx.card.name} — ${ctx.self.name} held initiative; opposing attack −2 power.`,
      ],
    };
  },
};
